export default "__VITE_ASSET__DfksxkLN__"